export const DISABLE_USER_SUCCESS = 'DISABLE_USER_SUCCESS';

export const disableUserSuccess = () => ({
    type: DISABLE_USER_SUCCESS,
});
